// extracted by mini-css-extract-plugin
export default {"row":"footer_row__yOLKp","column":"footer_column__GXMOP","CTA":"footer_CTA__aeH5k","socials":"footer_socials__vJT4V"};